import React, { useEffect, useState, useRef } from "react";
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import "react-datetime/css/react-datetime.css";
import '@1stquad/react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';
import Datetime from "react-datetime";
import moment from "moment";
import ExtendOneDayPlan from "./ExtendOneDayPlan";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";


const OneDayPlan = (props) => {
    const { onBack, proceedToCheckout, plan, updateTimeZone, updateDate, formData, eventStartDate, eventEndDate,userData } = props;
    const [selectedTimezone, setSelectedTimezone] = useState(
        Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    const [date, setdate] = useState(moment());
    var yesterday = moment().subtract(1, "day");
    const [endDate, setEndDate] = useState(moment().add(7, "days"));
    const [loading, setLoading] = useState(false);
    const myRefname = useRef(null);
    const myRefendName = useRef(null);
    const [confirmPurchase, setConfirmPurchase] = useState(false);
    const [numberofDaysError, setNumberofDaysError] = useState(false);
    const [extendError, setExtendError] = useState(false);
    const [extendPlan,setExtendPlan] = useState(false);

    const handleChange = newDate => {
        updateDate('startDate', newDate);
        setdate(moment(newDate));
        handleChangeEndDate(moment(newDate).add(7, "days"));
    };
    const handleChangeEndDate = newDate => {
        updateDate('endDate', newDate);
        setEndDate(moment(newDate));
    };

    const changeTimeZone = (e) => {
        updateTimeZone(e.value)
        setSelectedTimezone(e);
    }

    const getDateDifference = () => {

        let extraMinutes = moment(endDate).diff(moment(date), 'minutes');

        if (isNaN(extraMinutes)) {
            return 0;
        }

        if (extraMinutes > 0) {
            if (extraMinutes > 1440) {
                extraMinutes = Math.ceil(extraMinutes / 1440);
            } else {
                extraMinutes = 1;
            }
        } else {
            return 0;
        }
        return extraMinutes;
    }

    const handleBackButton = () => {
        updateDate('beforeafter', '');
        updateDate('numberofdays', '');
        onBack()
    }

    const purchase = (isExtendPlan) => {

        if (isExtendPlan) {
            if (formData.beforeafter == '') {
                setExtendError(true);
                return;
            }else if (formData.numberofdays == '') {
                setNumberofDaysError(true);
                return;
            }else{
                setLoading(true);
                proceedToCheckout({ ...plan,extendedPlan:true }, () => setLoading(false));
            }
            }else{
                if (confirmPurchase) {
                    setLoading(true)
                    proceedToCheckout({ ...plan }, () => setLoading(false));
                } else {
                    setConfirmPurchase(true);
                }
        }
    }
    const valid = function (current) {
        return current.isAfter(yesterday);
    };

    const endDateValid = function (current) {
        return current.isAfter(date);
    };

    useEffect(() => {
        updateDate('startDate', date);
        updateDate('endDate', endDate);
        if(eventEndDate && eventEndDate!=''){
            if(userData && Object.keys(userData).length>0){
                const timezone = userData.UserPlan.timeZone;
                let currentTimeStamp = moment(new Date()).format("X");
                if(timezone!=""){
                    currentTimeStamp = moment(new Date()).tz(timezone).format("X")
                }
                if(eventEndDate > parseInt(currentTimeStamp)){
                    setExtendPlan(true);
                }
            }
        }
    }, [])

    const daysDifference = getDateDifference();

    return <div className="event_plan">
        <div className="container_custom">
            {!extendPlan ? <div className="event_plan_wrapper">
                <div className="row newplan">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Select TimeZone</label>
                            <TimezoneSelect
                                value={selectedTimezone}
                                onChange={changeTimeZone}
                                timezones={{
                                    ...allTimezones,
                                    'America/Lima': 'Pittsburgh',
                                    'Europe/Berlin': 'Frankfurt',
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <label>Starting Date</label>
                        <div className="input-group">
                            <Datetime
                                value={date}
                                isValidDate={valid}
                                closeOnSelect={true}
                                onChange={(e) => handleChange(e)}
                                dateFormat="DD-MM-YYYY"
                                timeFormat={false} 
                                // timeFormat="HH:mm"
                                className="form-control custom-control p-0"
                                ref={myRefname}
                            />
                            <span className="input-group-text">
                                <i className="fa fa-calendar-days"></i>
                            </span>
                        </div>
                    </div>

                  

                    <div className="col-sm-6">
                        <input className="form-control mt-4" type="text" readOnly={true} disabled={true} value={moment(endDate).format("DD-MM-YYYY")}/>
                    </div>
                    <input type="hidden" name="" id="event_detail_check_Before_Purchage" value="0" />
                </div>
                <div className="form_summury event_bill mt-3">
                    <div className="form-group">
                        <div className="f-between">
                            <div id="numberOfDays1" className="fs-4 fw-bold text-dark">{daysDifference} {daysDifference > 1 ? 'Days' : 'Day'}</div>
                            <div id="price1" className="fs-4 fw-bold text-dark">${plan.planPrice}</div>
                        </div>
                        {confirmPurchase && <div id="confirmMessage">
                            <div className="alert fade show my-3 bg-light">
                                <div className="alert-text" id="confirmMessageUser"><strong>Confirmation:</strong>  Your <strong>Event Plan</strong> is scheduled to operate from <strong>{date ? moment(date).format('DD-MM-YYYY HH:mm') : ''}</strong> till <strong>{endDate ? moment(endDate).format('DD-MM-YYYY HH:mm') : ''}</strong>
                                    <strong> {(selectedTimezone && Object.keys(selectedTimezone).length > 0 && selectedTimezone.label) ? selectedTimezone.label : selectedTimezone}</strong>. Kindly review and proceed to purchase the plan.</div>
                            </div>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="coupon">
                                <div className="coupon-row">
                                    <div className="input-group">
                                        <span className="coupon-field coupon-field1 me-2">WAVE30</span>
                                        <a className="coupon-btn coupon-btn1" tabIndex="-1">
                                            <FontAwesomeIcon type={'regular'} icon={'copy'} iconClass={'text-gray-500 fs-6'} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div id="message1" className="text-danger"></div>
                        </div>
                        <div className="col-sm-6 text-end ">
                            <Button variant="link" onClick={() => handleBackButton()} className="cancelBtn cursor-pointer me-3" id="backtoplans">Back</Button>
                            <Button variant="primary" id="purchase1" className={`${loading ? 'spinner spinner-right disabled' : ''}`} onClick={() => purchase(false)}> Purchase
                                    Plan</Button>
                        </div>
                    </div>

                    <p className="event-notification fs-6 mt-4"><span className="fw-bold">Note:
                    </span>We recommend you to select the start date a few days prior to actual event, so as to cover the time for setup and curating updated content. 'Real-time updates' would be implemented 12 hours prior to start of your plan, to get you historical data for your account.</p>
                </div>
            </div> :
                <div className="event_plan_wrapper">
                    <ExtendOneDayPlan startDate={eventStartDate} endDate={eventEndDate} updateDetails={(key, value) => { setExtendError(false); setNumberofDaysError(false); updateDate(key, value) }} numberofDaysError={numberofDaysError} extendError={extendError} price={plan.planPrice} />
                    <div className="row">
                        <div className="col-12 text-end">
                            <div className="pay_btns purchase_plan pull-right">
                                <Button variant="link" onClick={() => handleBackButton()} className="cancelBtn cursor-pointer me-3" id="backtoplans">Back</Button>
                                <Button variant="primary" id="purchase1" className={`${loading ? 'spinner spinner-right disabled' : ''}`} onClick={() => purchase(true)}>Purchase
                                    Plan</Button>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </div>
    </div>
}

export default OneDayPlan;